import styled from "styled-components";
import { Placeholder } from "@eriksdigital/atomic-ui/components";

export const PlaceholderItemRow = styled(Placeholder)`
  margin-bottom: 0.5rem;
`;
